import request from './base'

export default {
  /**
   * 文章列表
   * params: {
   * "pageNum":"1",
   * "pageSize":"10",
   *  dto: {
   *    "status":"",
   *    "startDate":"2019-04-02",
   *    "endDate":"2019-04-12"
   *  }
   * }
   */
  queryInformationList: (commit, payload, mutation) => {
    let options = request.getOptions('/information/queryInformationList', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 机构信息列表
   * params: {
   * "pageNum":"1",
   * "pageSize":"10",
   * "queryType":"1",
   *  dto: {
   *    "status":"",
   *    "startDate":"2019-04-02",
   *    "endDate":"2019-04-12",
   *    "partnerType":"2"
   *  }
   * }
   */
  queryPartnerList: (commit, payload, mutation) => {
    let options = request.getOptions('/partner/queryPartnerList', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 机构认证列表
   */
  applypage: (commit, payload, mutation) => {
    let options = request.getOptions('/apply/page', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 文章认证
   */
  authenticationsuccess: (commit, payload, mutation) => {
    let options = request.getOptions('/information/authenticationsuccess', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 机构认证详情
   */
  applyquery: (commit, payload, mutation) => {
    let options = request.getOptions('/apply/query', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 机构认证通过
   */
  applyauthenticationsuccess: (commit, payload, mutation) => {
    let options = request.getOptions('/apply/authenticationsuccess', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 机构认证拒绝
   */
  applyauthenticationfailed: (commit, payload, mutation) => {
    let options = request.getOptions('/apply/authenticationfailed', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 机构认证图集详情
   */
  queryToShow: (commit, payload, mutation) => {
    let options = request.getOptions('/imagestemps/queryToShow', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 产品列表修改前
   */
  productQueryPageToShow: (commit, payload, mutation) => {
    let options = request.getOptions('/product/queryPageToShow', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 机构详情修改前
   */
  partnerQueryPageToShow: (commit, payload, mutation) => {
    let options = request.getOptions('/partner/queryToShows', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 图集列表查询修改前
   */
  atlassQueryPageToShow: (commit, payload, mutation) => {
    let options = request.getOptions('/atlass/pageToShow', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 图集列表查询修改前
   */
  partnerAuthenticationsuccess: (commit, payload, mutation) => {
    let options = request.getOptions('/partner/authenticationsuccess', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 图集列表查询修改前
   */
  partnerAuthenticationfailed: (commit, payload, mutation) => {
    let options = request.getOptions('/partner/authenticationfailed', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 个人中心个人信息
   */
  updateCustomer: (commit, payload, mutation) => {
    let options = request.getOptions('/customer/updateCustomer', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 个人中心个人信息
   */
  productAuthenticationsuccess: (commit, payload, mutation) => {
    let options = request.getOptions('/product/authenticationsuccess', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 个人中心个人信息
   */
  productAuthenticationfailed: (commit, payload, mutation) => {
    let options = request.getOptions('/product/authenticationfailed', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 设置热门
   */
  informationLabel: (commit, payload, mutation) => {
    let options = request.getOptions('/information/label', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 获取信息详情
   */
  queryInformationDetail: (commit, payload, mutation) => {
    let options = request.getOptions('/information/queryInformationDetail', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 删除文章
   */
  informationDelete: (commit, payload, mutation) => {
    let options = request.getOptions('/information/delete', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 删除文章
   */
  informationAuthenticationfailed: (commit, payload, mutation) => {
    let options = request.getOptions('/information/authenticationfailed', payload)
    return request.post(commit, options, mutation)
  }
}



// WEBPACK FOOTER //
// ./src/services/audit.js